export default "__VITE_ASSET__0b4517db__"